import getEnv from "@/config/env";
import { retrieveProdInformation } from "@/helpers/helper";

let dest_info = [
  {
    dest_phone_name: "COMPL_3104",
    dest_model_name: "VVX201",
    dest_sip_address: "3104@172.18.36.136",
    dest_ip_address: "172.18.36.136",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3106",
    dest_model_name: "VVX201",
    dest_sip_address: "3106@172.18.36.137",
    dest_ip_address: "172.18.36.137",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3107",
    dest_model_name: "VVX201",
    dest_sip_address: "3107@172.18.36.138",
    dest_ip_address: "172.18.36.138",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3108",
    dest_model_name: "VVX201",
    dest_sip_address: "3108@172.18.36.139",
    dest_ip_address: "172.18.36.139",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3111",
    dest_model_name: "VVX201",
    dest_sip_address: "3111@172.18.36.140",
    dest_ip_address: "172.18.36.140",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3112",
    dest_model_name: "VVX201",
    dest_sip_address: "3112@172.18.36.141",
    dest_ip_address: "172.18.36.141",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3114",
    dest_model_name: "VVX201",
    dest_sip_address: "3114@172.18.36.142",
    dest_ip_address: "172.18.36.142",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3115",
    dest_model_name: "VVX250",
    dest_sip_address: "3115@172.18.36.146",
    dest_ip_address: "172.18.36.146",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3119",
    dest_model_name: "VVX250",
    dest_sip_address: "3119@172.18.36.144",
    dest_ip_address: "172.18.36.144",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3120",
    dest_model_name: "VVX250",
    dest_sip_address: "3120@172.18.36.145",
    dest_ip_address: "172.18.36.145",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3122",
    dest_model_name: "VVX250",
    dest_sip_address: "3122@172.18.36.147",
    dest_ip_address: "172.18.36.147",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3123",
    dest_model_name: "VVX250",
    dest_sip_address: "3123@172.18.36.148",
    dest_ip_address: "172.18.36.148",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3124",
    dest_model_name: "VVX250",
    dest_sip_address: "3124@172.18.36.100",
    dest_ip_address: "172.18.36.100",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3125",
    dest_model_name: "VVX250",
    dest_sip_address: "3125@172.18.36.101",
    dest_ip_address: "172.18.36.101",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3126",
    dest_model_name: "VVX250",
    dest_sip_address: "3126@172.18.36.102",
    dest_ip_address: "172.18.36.102",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "COMPL_3127",
    dest_model_name: "VVX250",
    dest_sip_address: "3127@172.18.36.99",
    dest_ip_address: "172.18.36.99",
    dest_department: "企業倫理",
  },
  {
    dest_phone_name: "EAP_3308",
    dest_model_name: "VVX201",
    dest_sip_address: "3308@172.18.36.131",
    dest_ip_address: "172.18.36.131",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3309",
    dest_model_name: "VVX201",
    dest_sip_address: "3309@172.18.36.132",
    dest_ip_address: "172.18.36.132",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3310",
    dest_model_name: "VVX201",
    dest_sip_address: "3310@172.18.36.133",
    dest_ip_address: "172.18.36.133",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3311",
    dest_model_name: "VVX201",
    dest_sip_address: "3311@172.18.36.134",
    dest_ip_address: "172.18.36.134",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3312",
    dest_model_name: "VVX250",
    dest_sip_address: "3312@172.18.36.135",
    dest_ip_address: "172.18.36.135",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3313",
    dest_model_name: "VVX250",
    dest_sip_address: "3313@172.18.36.92",
    dest_ip_address: "172.18.36.92",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3314",
    dest_model_name: "VVX250",
    dest_sip_address: "3314@172.18.36.93",
    dest_ip_address: "172.18.36.93",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3315",
    dest_model_name: "VVX250",
    dest_sip_address: "3315@172.18.36.94",
    dest_ip_address: "172.18.36.94",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3316",
    dest_model_name: "VVX250",
    dest_sip_address: "3316@172.18.36.95",
    dest_ip_address: "172.18.36.95",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3317",
    dest_model_name: "VVX250",
    dest_sip_address: "3317@172.18.36.96",
    dest_ip_address: "172.18.36.96",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3318",
    dest_model_name: "VVX250",
    dest_sip_address: "3318@172.18.36.97",
    dest_ip_address: "172.18.36.97",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "EAP_3319",
    dest_model_name: "VVX250",
    dest_sip_address: "3319@172.18.36.98",
    dest_ip_address: "172.18.36.98",
    dest_department: "EAP",
  },
  {
    dest_phone_name: "KENKO_3993",
    dest_model_name: "VVX250",
    dest_sip_address: "KENKO_3993@172.18.36.195",
    dest_ip_address: "172.18.36.195",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4006",
    dest_model_name: "VVX250",
    dest_sip_address: "4006@172.18.41.7",
    dest_ip_address: "172.18.41.7",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4007",
    dest_model_name: "VVX250",
    dest_sip_address: "4007@172.18.41.8",
    dest_ip_address: "172.18.41.8",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4008",
    dest_model_name: "VVX250",
    dest_sip_address: "4008@172.18.41.9",
    dest_ip_address: "172.18.41.9",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4009",
    dest_model_name: "VVX250",
    dest_sip_address: "4009@172.18.41.10",
    dest_ip_address: "172.18.41.10",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4010",
    dest_model_name: "VVX250",
    dest_sip_address: "4010@172.18.41.11",
    dest_ip_address: "172.18.41.11",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4011",
    dest_model_name: "VVX250",
    dest_sip_address: "4011@172.18.36.129",
    dest_ip_address: "172.18.36.129",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4012",
    dest_model_name: "VVX250",
    dest_sip_address: "4012@172.18.36.125",
    dest_ip_address: "172.18.36.125",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4013",
    dest_model_name: "VVX250",
    dest_sip_address: "4013@172.18.41.14",
    dest_ip_address: "172.18.41.14",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4014",
    dest_model_name: "VVX250",
    dest_sip_address: "4014@172.18.36.128",
    dest_ip_address: "172.18.36.128",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4015",
    dest_model_name: "VVX250",
    dest_sip_address: "4015@172.18.41.16",
    dest_ip_address: "172.18.41.16",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4016",
    dest_model_name: "VVX250",
    dest_sip_address: "4016@172.18.41.17",
    dest_ip_address: "172.18.41.17",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4017",
    dest_model_name: "VVX250",
    dest_sip_address: "4017@172.18.41.18",
    dest_ip_address: "172.18.41.18",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4018",
    dest_model_name: "VVX250",
    dest_sip_address: "4018@172.18.41.19",
    dest_ip_address: "172.18.41.19",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4019",
    dest_model_name: "VVX250",
    dest_sip_address: "4019@172.18.36.127",
    dest_ip_address: "172.18.36.127",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4020",
    dest_model_name: "VVX250",
    dest_sip_address: "4020@172.18.41.21",
    dest_ip_address: "172.18.41.21",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4021",
    dest_model_name: "VVX250",
    dest_sip_address: "4021@172.18.36.130",
    dest_ip_address: "172.18.36.130",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4022",
    dest_model_name: "VVX250",
    dest_sip_address: "4022@172.18.36.126",
    dest_ip_address: "172.18.36.126",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4023",
    dest_model_name: "VVX250",
    dest_sip_address: "4023@172.18.41.24",
    dest_ip_address: "172.18.41.24",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4024",
    dest_model_name: "VVX250",
    dest_sip_address: "4024@172.18.41.25",
    dest_ip_address: "172.18.41.25",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4025",
    dest_model_name: "VVX250",
    dest_sip_address: "4025@172.18.41.26",
    dest_ip_address: "172.18.41.26",
    dest_department: "健康（京都）",
  },
  {
    dest_phone_name: "KENKO_4028",
    dest_model_name: "VVX250",
    dest_sip_address: "KENKO_4028@172.18.36.123",
    dest_ip_address: "172.18.36.123",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4029",
    dest_model_name: "VVX250",
    dest_sip_address: "KENKO_4029@172.18.36.124",
    dest_ip_address: "172.18.36.124",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4030",
    dest_model_name: "VVX250",
    dest_sip_address: "4030@172.18.36.103",
    dest_ip_address: "172.18.36.103",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4031",
    dest_model_name: "VVX250",
    dest_sip_address: "4031@172.18.36.104",
    dest_ip_address: "172.18.36.104",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4032",
    dest_model_name: "VVX250",
    dest_sip_address: "4032@172.18.36.105",
    dest_ip_address: "172.18.36.105",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4033",
    dest_model_name: "VVX250",
    dest_sip_address: "4033@172.18.36.106",
    dest_ip_address: "172.18.36.106",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4034",
    dest_model_name: "VVX250",
    dest_sip_address: "4034@172.18.36.107",
    dest_ip_address: "172.18.36.107",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4035",
    dest_model_name: "VVX250",
    dest_sip_address: "4035@172.18.36.108",
    dest_ip_address: "172.18.36.108",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4036",
    dest_model_name: "VVX250",
    dest_sip_address: "4036@172.18.36.109",
    dest_ip_address: "172.18.36.109",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4037",
    dest_model_name: "VVX250",
    dest_sip_address: "4037@172.18.36.110",
    dest_ip_address: "172.18.36.110",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4038",
    dest_model_name: "VVX250",
    dest_sip_address: "4038@172.18.36.111",
    dest_ip_address: "172.18.36.111",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4039",
    dest_model_name: "VVX250",
    dest_sip_address: "4039@172.18.36.112",
    dest_ip_address: "172.18.36.112",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4040",
    dest_model_name: "VVX250",
    dest_sip_address: "4040@172.18.36.113",
    dest_ip_address: "172.18.36.113",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4041",
    dest_model_name: "VVX250",
    dest_sip_address: "4041@172.18.36.114",
    dest_ip_address: "172.18.36.114",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4042",
    dest_model_name: "VVX250",
    dest_sip_address: "4042@172.18.36.115",
    dest_ip_address: "172.18.36.115",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4043",
    dest_model_name: "VVX250",
    dest_sip_address: "4043@172.18.36.116",
    dest_ip_address: "172.18.36.116",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4044",
    dest_model_name: "VVX250",
    dest_sip_address: "4044@172.18.36.117",
    dest_ip_address: "172.18.36.117",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4045",
    dest_model_name: "VVX250",
    dest_sip_address: "4045@172.18.36.118",
    dest_ip_address: "172.18.36.118",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4046",
    dest_model_name: "VVX250",
    dest_sip_address: "4046@172.18.36.119",
    dest_ip_address: "172.18.36.119",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4047",
    dest_model_name: "VVX250",
    dest_sip_address: "4047@172.18.36.120",
    dest_ip_address: "172.18.36.120",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4048",
    dest_model_name: "VVX250",
    dest_sip_address: "4048@172.18.36.121",
    dest_ip_address: "172.18.36.121",
    dest_department: "健康",
  },
  {
    dest_phone_name: "KENKO_4049",
    dest_model_name: "VVX250",
    dest_sip_address: "4049@172.18.36.122",
    dest_ip_address: "172.18.36.122",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3500",
    dest_model_name: "VVX250",
    dest_sip_address: "3500@172.18.36.164",
    dest_ip_address: "172.18.36.164",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3501",
    dest_model_name: "VVX250",
    dest_sip_address: "3501@172.18.36.165",
    dest_ip_address: "172.18.36.165",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3502",
    dest_model_name: "VVX250",
    dest_sip_address: "3502@172.18.36.166",
    dest_ip_address: "172.18.36.166",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3503",
    dest_model_name: "VVX250",
    dest_sip_address: "3503@172.18.36.167",
    dest_ip_address: "172.18.36.167",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3504",
    dest_model_name: "VVX250",
    dest_sip_address: "3504@172.18.36.168",
    dest_ip_address: "172.18.36.168",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3505",
    dest_model_name: "VVX201",
    dest_sip_address: "3505@172.18.36.169",
    dest_ip_address: "172.18.36.169",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3506",
    dest_model_name: "VVX201",
    dest_sip_address: "3506@172.18.36.170",
    dest_ip_address: "172.18.36.170",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3507",
    dest_model_name: "VVX250",
    dest_sip_address: "3507@172.18.36.171",
    dest_ip_address: "172.18.36.171",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3508",
    dest_model_name: "VVX201",
    dest_sip_address: "3508@172.18.36.172",
    dest_ip_address: "172.18.36.172",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3509",
    dest_model_name: "VVX201",
    dest_sip_address: "3509@172.18.36.173",
    dest_ip_address: "172.18.36.173",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3510",
    dest_model_name: "VVX201",
    dest_sip_address: "3510@172.18.36.174",
    dest_ip_address: "172.18.36.174",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3511",
    dest_model_name: "VVX250",
    dest_sip_address: "SOC_3511@172.18.36.194",
    dest_ip_address: "172.18.36.194",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3512",
    dest_model_name: "VVX201",
    dest_sip_address: "3512@172.18.36.175",
    dest_ip_address: "172.18.36.175",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3513",
    dest_model_name: "VVX201",
    dest_sip_address: "3513@172.18.36.176",
    dest_ip_address: "172.18.36.176",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3514",
    dest_model_name: "VVX201",
    dest_sip_address: "3514@172.18.36.177",
    dest_ip_address: "172.18.36.177",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3515",
    dest_model_name: "VVX250",
    dest_sip_address: "3515@172.18.36.178",
    dest_ip_address: "172.18.36.178",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3516",
    dest_model_name: "VVX201",
    dest_sip_address: "3516@172.18.36.179",
    dest_ip_address: "172.18.36.179",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3517",
    dest_model_name: "VVX201",
    dest_sip_address: "3517@172.18.36.180",
    dest_ip_address: "172.18.36.180",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3518",
    dest_model_name: "VVX201",
    dest_sip_address: "3518@172.18.36.181",
    dest_ip_address: "172.18.36.181",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3519",
    dest_model_name: "VVX201",
    dest_sip_address: "3519@172.18.36.182",
    dest_ip_address: "172.18.36.182",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3520",
    dest_model_name: "VVX201",
    dest_sip_address: "3520@172.18.36.183",
    dest_ip_address: "172.18.36.183",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3521",
    dest_model_name: "VVX201",
    dest_sip_address: "3521@172.18.36.184",
    dest_ip_address: "172.18.36.184",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3522",
    dest_model_name: "VVX250",
    dest_sip_address: "3522@172.18.36.185",
    dest_ip_address: "172.18.36.185",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3523",
    dest_model_name: "VVX201",
    dest_sip_address: "3523@172.18.36.186",
    dest_ip_address: "172.18.36.186",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "SOC_3524",
    dest_model_name: "VVX250",
    dest_sip_address: "3524@172.18.36.91",
    dest_ip_address: "172.18.36.91",
    dest_department: "ソーシャル",
  },
  {
    dest_phone_name: "stc_3601",
    dest_model_name: "VVX250",
    dest_sip_address: "3601@172.18.36.187",
    dest_ip_address: "172.18.36.187",
    dest_department: "サポートデスク",
  },
  {
    dest_phone_name: "KURASHI_3200",
    dest_model_name: "VVX201",
    dest_sip_address: "3200@172.18.36.149",
    dest_ip_address: "172.18.36.149",
    dest_department: "暮らし",
  },
  {
    dest_phone_name: "KURASHI_3201",
    dest_model_name: "VVX201",
    dest_sip_address: "3201@172.18.36.150",
    dest_ip_address: "172.18.36.150",
    dest_department: "暮らし",
  },
  {
    dest_phone_name: "KURASHI_3202",
    dest_model_name: "VVX201",
    dest_sip_address: "3202@172.18.36.151",
    dest_ip_address: "172.18.36.151",
    dest_department: "暮らし",
  },
  {
    dest_phone_name: "KURASHI_3203",
    dest_model_name: "VVX201",
    dest_sip_address: "3203@172.18.36.152",
    dest_ip_address: "172.18.36.152",
    dest_department: "暮らし",
  },
  {
    dest_phone_name: "TAS_3204",
    dest_model_name: "VVX201",
    dest_sip_address: "3204@172.18.36.153",
    dest_ip_address: "172.18.36.153",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "TAS_3205",
    dest_model_name: "VVX201",
    dest_sip_address: "3205@172.18.36.154",
    dest_ip_address: "172.18.36.154",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "TAS_3206",
    dest_model_name: "VVX201",
    dest_sip_address: "3206@172.18.36.155",
    dest_ip_address: "172.18.36.155",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "KURASHI_3207",
    dest_model_name: "VVX201",
    dest_sip_address: "3207@172.18.36.156",
    dest_ip_address: "172.18.36.156",
    dest_department: "暮らし",
  },
  {
    dest_phone_name: "KURASHI_3208",
    dest_model_name: "VVX201",
    dest_sip_address: "3208@172.18.36.157",
    dest_ip_address: "172.18.36.157",
    dest_department: "暮らし",
  },
  {
    dest_phone_name: "ccg_3209",
    dest_model_name: "VVX201",
    dest_sip_address: "3209@172.18.36.158",
    dest_ip_address: "172.18.36.158",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "ccg_3210",
    dest_model_name: "VVX201",
    dest_sip_address: "3210@172.18.36.159",
    dest_ip_address: "172.18.36.159",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "stc_3211",
    dest_model_name: "VVX201",
    dest_sip_address: "3211@172.18.36.160",
    dest_ip_address: "172.18.36.160",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "stc_3212",
    dest_model_name: "VVX250",
    dest_sip_address: "3212@172.18.36.161",
    dest_ip_address: "172.18.36.161",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "TAS_3213",
    dest_model_name: "VVX201",
    dest_sip_address: "3213@172.18.36.162",
    dest_ip_address: "172.18.36.162",
    dest_department: "TAS",
  },
  {
    dest_phone_name: "KURASHI_3217",
    dest_model_name: "VVX250",
    dest_sip_address: "3217@172.18.36.163",
    dest_ip_address: "172.18.36.163",
    dest_department: "暮らし",
  },
];

const SHEET_ID = getEnv("VUE_APP_SHEET_ID") || '1U4af0bCt_C_WtsLs2mVWbPOgFJFEsw5loZMrb85ojtg';
const GID = getEnv("VUE_APP_DESTINATION_INFO_GID") || '1288615779';

try {
const data = await retrieveProdInformation(SHEET_ID, GID);

if (!data?.table?.rows || !Array.isArray(data.table.rows)) {
  console.warn("Invalid Google Sheet response:", data);
} else {
  const rows = data.table.rows.slice(1).map((row) => ({
    dest_phone_name: row.c[0]?.v || "",
    dest_model_name: row.c[1]?.v || "",
    dest_sip_address: row.c[2]?.v || "",
    dest_ip_address: row.c[3]?.v || "",
    dest_department: row.c[4]?.v || "",
  }));

  if (rows.length > 0) {
    dest_info = rows;
  }
}
} catch (error) {
  console.error("Failed to load destination info:", error);
}


export default dest_info;

export const getDestFullPhoneName = (phone_number) => {
  const dest = dest_info.find(
    (item) => {
      return item.dest_phone_name.slice(-4) == phone_number;
    }
  );
  return dest ? dest.dest_phone_name : phone_number;
}

export const getDestinationInfoByExtension = (phone_number) => {
  return (
    dest_info.find(
      (item) => item.dest_phone_name.slice(-4) == phone_number
    ) || null
  );
};
